import React from 'react'
import {
    Modal, ModalBody, ModalHeader
} from 'reactstrap'
import axios from "axios/index"
import moment from 'moment'
import 'moment/locale/ro'

export default class OfferForm extends React.Component {
    constructor(props) {
        super(props)
        axios.defaults.headers.common['Accept'] = 'application/json'
        this.prices = this.props.prices.keys
        this.price_labels = this.props.prices.labels
        this.state = {
            open: false,
            date: null,
            errors: [],
            provider: {},
            location: {},
            group: {},
            loading: false,
            p1: '', p2: '', p3: '', p4: '', p5: '', rental_offer_id: ''
        }
        moment.locale('ro')
    }

    toggleDialog = () => {
        const open = this.state.open
        this.setState({
            open: !open,
        })
    }

    resetForm = () => {
        this.setState({
            errors: [], provider: {}, location: {}, group: {}, loading: false,
            p1: '', p2: '', p3: '', p4: '', p5: '', rental_offer_id: '', saving: false, errors: [], confirm_copy: null
        })

    }

    addOffer = (plg_id, start, end) => {
        this.resetForm()
        this.setState({loading: true, open: true, plg_id: plg_id, start_date: start, end_date: end})
        axios.get(`${this.props.baseUrl}/rental_calendars/new_offer?provider_location_group_id=${plg_id}&start_date=${start.format('YYYY-MM-DD')}&end_date=${end.format('YYYY-MM-DD')}`)
            .then(res => {
                    this.setState({...res.data, loading: false})
                }
            )
    }

    editOffer = (plg_id, ro_id) => {
        this.resetForm()
        this.setState({loading: true, open: true})
        axios.get(`${this.props.baseUrl}/rental_calendars/edit_offer?provider_location_group_id=${plg_id}&rental_offer_id=${ro_id}`)
            .then(res => {
                    this.setState({...res.data, loading: false})
                }
            )
    }


    renderDialog = () => {
        return (
            <div>
                <Modal isOpen={this.state.open} toggle={this.toggleDialog} style={{width: 460}}>
                    <ModalHeader toggle={this.toggleDialog}><span
                        className={'small'}>{this.state.rental_offer_id ? 'Editeaza' : 'Adauga'} Oferta</span></ModalHeader>
                    <ModalBody>
                        {this.state.loading &&
                        <div>Loading ...</div>
                        }
                        {this.state.errors.count > 0 &&
                        <div>
                            {this.state.errors.join(' ')}
                        </div>
                        }
                        {!this.state.loading && !this.state.confirm_copy && this.renderItem() }
                        {!this.state.loading && this.state.confirm_copy && this.renderConfirm(this.state.confirm_copy)}
                    </ModalBody>
                </Modal>
            </div>
        )
    }

    onChangePrice = (e) => {
        this.setState({[e.target.name]: e.target.value})
    }

    saveOffer = () => {
        this.state.rental_offer_id ? this.updateOffer() : this.createOffer()
    }


    createOffer = () => {
        this.setState({saving: true})
        const that = this
        axios.post(`${this.props.baseUrl}/rental_offers.json`, this.queryObject())
            .then(function (res) {
                if (res.data && res.data.success && res.data.id) {
                    that.props.addOffer && that.props.addOffer([moment(res.data.start_date), moment(res.data.end_date), res.data.id])
                    that.toggleDialog()
                }
                else {
                    that.setState({errors: res.data.errors || ['Eroare salvare'], saving: false})
                }
            })
    }

    queryObject = () => {

        return {
            authenticity_token: CSRF_TOKEN,
            rental_offer: {
                provider_location_group_id: this.state.group.id,
                start_date: this.state.start_date,
                end_date: this.state.end_date,
                min_days: 2,
                p1: this.state.p1,
                p2: this.state.p2,
                p3: this.state.p3,
                p4: this.state.p4,
                p5: this.state.p5
            }
        }
    }

    updateOffer = () => {
        this.setState({saving: true})
        const that = this
        axios.patch(`${this.props.baseUrl}/rental_offers/${this.state.rental_offer_id}.json`, this.queryObject())
            .then(function (res) {
                if (res.data && res.data.success) {
                    that.toggleDialog()
                }
                else {
                    that.setState({errors: res.data.errors || ['Eroare salvare'], saving: false})
                }
            })
    }
    copyOffer = (confirm = 0) => {
        this.setState({saving: true})
        const that = this
        axios.patch(`${this.props.baseUrl}/rental_offers/${this.state.rental_offer_id}/copy`, {
            authenticity_token: CSRF_TOKEN,
            confirm: confirm
        })
            .then(function (res) {
                if (res.data && res.data.success) {
                    if (res.data.confirm_copy)
                        that.setState({confirm_copy: res.data.confirm_copy, saving: false})
                    else
                        that.toggleDialog()
                }
                else {
                    that.setState({errors: res.data.errors || ['Eroare salvare'], saving: false})
                }
            })
    }

    deleteOffer = () => {
        this.setState({saving: true})
        const that = this
        axios.delete(`${this.props.baseUrl}/rental_offers/${this.state.rental_offer_id}.json`, {
            params: {authenticity_token: CSRF_TOKEN, plg_id: this.state.group.id}
        })
            .then(function (res) {
                if (res.data && res.data.success) {
                    that.props.deleteOffer && that.props.deleteOffer()
                    // that.toggleDialog()
                }
                else {
                    that.setState({errors: res.data.errors || ['Eroare salvare'], saving: false})
                }
            })
    }

    renderConfirm = (confirm_copy) => {
        return (
            <div>
                Urmatoarele oferte vor fi sterse si inlocuite pe acest grup:
                {confirm_copy.map((c, index) =>
                    <div key={index}>
                        {c.location} {c.start_date} {c.end_date}
                    </div>)}
                <br/>
                <input type="button" name="copy" value="Confirma"
                       className="btn btn-success mr-4"
                       data-disable-with="Confirma"
                       onClick={() => this.copyOffer(1)}/>
            </div>
        )
    }

    renderItem = () => {
        return (
            <div style={{paddingLeft: 20, paddingRight: 20}}>
                <div className={'row'} style={{borderBottom: '1px solid lightgray', width: '100%'}}>
                    <div className={'col'}>
                        <h5>{this.state.provider.name}</h5>
                    </div>
                    <div className={'col'}>
                        <h5>{this.state.location.name}</h5>
                    </div>
                    <div className={'col'}>
                        <h5>{this.state.group.name}</h5>
                    </div>
                </div>
                <div>
                    De la <span
                    className={'text-danger'}>{moment(this.state.start_date).format('DD-MMM-YYYY')}</span> pana la <span
                    className={'text-danger'}>{moment(this.state.end_date).format('DD-MMM-YYYY')}</span>
                </div>
                <div>
                    {(this.state.errors && this.state.errors.length > 0) &&
                    this.state.errors.map((e, index) => <div className={'error'} key={index}>{e}</div>)
                    }

                </div>
                <div className={'row'}>
                    <div className={'col'}>
                        {this.prices.map((p, index) =>
                            <div className="input currency optional my-2" key={index}>
                                <div className="input-group form-inline">
                                    <label className="currency optional control-label form-inline"
                                           style={{width: 200}}>{this.price_labels[index]}</label>
                                    <input className="currency optional form-control form-inline" type="text"
                                           name={p} autoComplete="off" value={this.state[p]}
                                           onChange={this.onChangePrice}
                                           style={{width: 100}}
                                    />
                                    <div className="input-group-append input-group-text">€</div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className={'row mt-4'}>
                    <div className={'col'} style={{textAlign: 'center'}}>
                        {this.state.rental_offer_id &&
                        <span>
                        <input type="button" name="delete" value="Sterge Oferta" className="btn btn-danger mr-4"
                               data-disable-with="Sterge Oferta" disabled={this.state.saving}
                               onClick={this.deleteOffer}/>
                            {this.props.admin &&
                            <a className="btn btn-primary mr-4 text-white"  onClick={() => this.copyOffer(0)}>Copie pe toate locatiile</a>
                            }
                            </span>
                        }
                        <input type="submit" name="commit" value="Salveaza Oferta" className="btn btn-primary mr-4"
                               data-disable-with="Salveaza Oferta" onClick={this.saveOffer}
                               disabled={this.state.saving}/>
                    </div>
                </div>
            </div>
        )
    }


    render() {
        return (
            <div>
                {this.renderDialog()}
            </div>
        )
    }
}